export enum ProfilesListMode {
  Cards = "cards",
  Table = "table"
}
